module.exports = __webpack_public_path__ + "img/taylorl.aab4c291.jpg";